import { render, staticRenderFns } from "./TemplatePublishableListingItem.vue?vue&type=template&id=790ad99a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplatePublishableListingItem.vue?vue&type=script&lang=js&"
export * from "./TemplatePublishableListingItem.vue?vue&type=script&lang=js&"
import style0 from "../../Style/template-publishable-listing-item.scss?vue&type=style&index=0&id=790ad99a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ad99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790ad99a')) {
      api.createRecord('790ad99a', component.options)
    } else {
      api.reload('790ad99a', component.options)
    }
    module.hot.accept("./TemplatePublishableListingItem.vue?vue&type=template&id=790ad99a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('790ad99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplatePublishableListingItem.vue"
export default component.exports